var $83a095cffcc42806$exports = {};
$83a095cffcc42806$exports = {
    "colorSwatchPicker": `\xc9chantillons de couleurs`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `S\xe9lectionner un \xe9l\xe9ment`,
    "tableResizer": `Redimensionneur`
};


export {$83a095cffcc42806$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
